import React from "react";
import Header from "../header/header";
import Footer from "../footer/footer";
import NavBar from "../nav/nav-bar";
import ReportNav from "./report-nav";
import { useState } from "react";
// import axios from "axios";
import Service from "../webservice/http";
import { useEffect } from "react";
import ForexViewmore from "./forexViewmore";
import { useHistory } from "react-router-dom";
import ClipLoader from "react-spinners/ClipLoader";
import { debounce } from "lodash";
import { storage } from "../utils/storage";
import ReportFilter from "./report-filter";
import { FaFilter } from "react-icons/fa";
import ReportFilterBanner from "./report-filter-banner";

function Agentscorecard() {
  const history = useHistory();
  const role = storage.getItem("role");
  const isAgentRole =
    role === "Agent" ||
    role === "Agenth" ||
    role === "Agent Collections" ||
    role.includes("Agent");
  const [open, setOpen] = useState(false);
  // const [open1, setopen1] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState();
  const [scorecardData, setScorecardData] = useState([]);
  const [error, setError] = useState();
  const services = new Service();
  const [id, setid] = useState("");
  const [search, setSearch] = useState("");

  const [reportFilterWidth, setReportFilterWidth] = useState(0);
  const [isReportFilterOpen, setIsReportFilterOpen] = useState(false);
  const [reportFilters, setReportFilters] = useState({});

  const changeReportFilterWidth = () => {
    if (reportFilterWidth === 550) {
      setReportFilterWidth(0);
      setIsReportFilterOpen(false);
    } else {
      setReportFilterWidth(550);
      setIsReportFilterOpen(true);
    }
  };

  const handleReportFilterApply = (appliedFilters) => {
    setReportFilters(appliedFilters);
  };

  const handleReportFilterReset = () => {
    setReportFilters({});
  };

  const debouncedSearch = debounce((value) => setSearch(value), 500);

  const buildQueryParams = (filters) => {
    const params = new URLSearchParams();
    const mapping = {
      lob: "lob_name",
      manager: "manager_name",
      team_lead: "team_lead_name",
      agent: "agent_name",
      dca_organization: "dca_organization_name",
      dca_manager: "dca_manager_name",
      dca_team: "dca_team_lead_name",
      dca_agent: "dca_agent_name",
      collection_strategy: "collection_strategy",
      product_type: "product_name",
      time_period: "period",
      from_date: "from_date",
      to_date: "to_date",
      bucket_type: "bucket_type",
    };
    for (const [key, value] of Object.entries(filters)) {
      if (mapping[key] && value) {
        params.append(mapping[key], value);
      } else if (value && !mapping[key]) {
        params.append(key, value);
      }
    }
    return params.toString();
  };

  function fetchAgentData() {
    setLoading(true);
    const params = new URLSearchParams();
    if (search) params.append("search", search);
    const qs = params.toString().replace(/\+/g, "%20");
    const url = `api/report/agent_details/${qs ? `?${qs}` : ""}`;
    services.get(url).then((res) => {
      setData(res);
      setLoading(false);
    });
  }

  function fetchScorecardData() {
    setLoading(true);
    const parts = [];
    if (search) parts.push(`search=${encodeURIComponent(search)}`);
    const filterQs = buildQueryParams(reportFilters);
    if (filterQs) parts.push(filterQs);
    const qs = parts.join("&").replace(/\+/g, "%20");
    const url = `api/call_verification/hierarchy-agent-scorecard/${
      qs ? `?${qs}` : ""
    }`;
    services.get(url).then((res) => {
      setScorecardData(res?.agent_scorecards || []);
      setLoading(false);
    });
  }

  // console.log(data);
  useEffect(() => {
    if (isAgentRole) {
      fetchAgentData();
    } else {
      fetchScorecardData();
    }
  }, [search, reportFilters]);

  // console.log(data);
  const styles = {
    redIcon: {
      float: "inherit",
      color: "red",
    },
    greenIcon: {
      float: "inherit",
      color: "green",
    },
    alignTextCenter: {
      textAlign: "center",
    },
  };

  return (
    <div className="dashboard-body" style={{ paddingBottom: "0px" }}>
      <Header />
      <NavBar />

      <div>
        <div className="container-fluid">
          <div className="my-call bg-white">
            <div
              className="side-panel-with-table clearfix"
              style={{ display: "flex" }}
            >
              <ReportNav />

              <div className="call-table">
                {!isAgentRole && !loading && (
                  <ReportFilterBanner
                    filters={reportFilters}
                    onClear={handleReportFilterReset}
                  />
                )}
                <div className="my-calls-column">
                  <div className="calls-top-pannel">
                    <div className="row">
                      <div className="col-lg-6">
                        <div className="pannel-heading clearfix">
                          <div className="pannel-heading-icon">
                            <i
                              className="fa fa-snowflake-o"
                              aria-hidden="true"
                            ></i>
                          </div>
                          <div className="pannel-heading-info">
                            <h3>Agents Scorecard </h3>
                            <p>Details</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {isAgentRole ? (
                  <>
                    <div className="flex w-full mt-10 justify-between px-8 mb-8 ">
                      <div
                        className="bg-white relative p-2 h-24  flex  gap-2 flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px" }}
                      >
                        <div className="text-2xl font-bold">
                          Total No of Calls
                        </div>
                        <div className="text-2xl">
                          {data?.overall_info?.total_calls}
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#EF2758" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 flex gap-2  flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px" }}
                      >
                        <div className="text-2xl font-bold">
                          Call resolution
                        </div>
                        <div className="text-2xl">
                          {data?.overall_info?.call_resolution}%
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "green" }}
                        ></div>
                      </div>
                      <div
                        className="bg-white relative p-2 flex gap-2  flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden"
                        style={{ height: "90px" }}
                      >
                        <div className="text-2xl font-bold">Intent</div>
                        <div className="text-2xl">
                          {data?.overall_info?.intent}%
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "#FFF974" }}
                        ></div>
                      </div>
                      <div
                        className=" bg-white relative p-2 flex gap-2  flex-col justify-center w-1/5 border border-gray-300 text-center mx-2 rounded overflow-hidden items-center "
                        style={{ height: "90px" }}
                      >
                        <div className="text-2xl font-bold">
                          Average call duration
                        </div>
                        <div className="text-2xl">
                          {data?.overall_info?.average_call_duration} mins
                        </div>
                        <div
                          className="absolute h-full w-1 left-0 top-0"
                          style={{ backgroundColor: "blue" }}
                        ></div>
                      </div>
                    </div>
                    <div className="flex  justify-end mb-10 mt-10">
                      <input
                        onChange={(event) =>
                          debouncedSearch(event.target.value)
                        }
                        type="text"
                        placeholder="Search by agent name"
                        className="search-tag flex  justify-end"
                        style={{
                          border: "none",
                          background: "#eef2f5",
                          borderRadius: "10px",
                          width: "250px",
                          outline: "none",
                          paddingLeft: "8px",
                          height: "35px",
                        }}
                      />
                    </div>

                    <table className="ss">
                      <thead>
                        <tr>
                          <th>
                            <p>Agent name</p>
                          </th>
                          <th>
                            <p>Total calls</p>
                          </th>
                          <th>
                            <p>Call answered</p>
                          </th>
                          <th>
                            <p>Language</p>
                          </th>
                          <th>
                            <p>Call resolution (%)</p>
                          </th>
                          <th>
                            <p>Intent %</p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading && (
                          <tr>
                            <td colSpan="6" style={{ textAlign: "center" }}>
                              <ClipLoader color="#2056FF" size="50px" />
                            </td>
                          </tr>
                        )}
                        {data?.agents?.length === 0 && !loading ? (
                          <tr className="text-center">
                            <td
                              colSpan="6"
                              style={{ textAlign: "center" }}
                              className="text-gray-500"
                            >
                              No agents found
                            </td>
                          </tr>
                        ) : (
                          data?.agents?.map((e, i) => (
                            <tr
                              onClick={() => {
                                history.push(
                                  `/reports/agent-scorecard/${e?.id}`
                                );
                                setid(e?.id);
                              }}
                              className="p-up cursor-pointer"
                              key={i}
                            >
                              <td>
                                <p>{e?.agent_name}</p>
                              </td>
                              <td>
                                <p>{e?.agent_total_calls}</p>
                              </td>
                              <td>
                                <p>{e?.calls_answered}</p>
                              </td>
                              <td>
                                <p>{e?.language}</p>
                              </td>
                              <td>
                                <p>{e?.call_resolution}</p>
                              </td>
                              <td>
                                <p>{e?.intent}</p>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>
                ) : (
                  <>
                    <div className="flex  justify-end mb-10 mt-10">
                      <input
                        onChange={(event) =>
                          debouncedSearch(event.target.value)
                        }
                        type="text"
                        placeholder="Search by agent name"
                        className="search-tag flex  justify-end"
                        style={{
                          border: "none",
                          background: "#eef2f5",
                          borderRadius: "10px",
                          width: "250px",
                          outline: "none",
                          paddingLeft: "8px",
                          height: "35px",
                        }}
                      />
                    </div>

                    <table className="ss">
                      <thead>
                        <tr>
                          <th>
                            <p>Agent Name</p>
                          </th>
                          <th>
                            <p>Calls Handled</p>
                          </th>
                          <th>
                            <p>PTP Generated</p>
                          </th>
                          <th>
                            <p>Kept Rate</p>
                          </th>

                          <th>
                            <p>Collected</p>
                          </th>
                          <th>
                            <p>Target</p>
                          </th>
                          <th>
                            <p>QA Score</p>
                          </th>
                          <th>
                            <p>AHT</p>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {loading && (
                          <tr>
                            <td colSpan="7" style={{ textAlign: "center" }}>
                              <ClipLoader color="#2056FF" size="50px" />
                            </td>
                          </tr>
                        )}
                        {scorecardData?.length === 0 && !loading ? (
                          <tr className="text-center">
                            <td
                              colSpan="7"
                              style={{ textAlign: "center" }}
                              className="text-gray-500"
                            >
                              No agents found
                            </td>
                          </tr>
                        ) : (
                          scorecardData?.map((e, i) => (
                            <tr
                              className="p-up"
                              key={i}
                              // onClick={() => {
                              //   history.push(
                              //     `/reports/agent-scorecard/${e?.agent_id}`
                              //   );
                              //   setid(e?.id);
                              // }}
                            >
                              <td>
                                <p>{e?.agent_name}</p>
                              </td>
                              <td>
                                <p>{e?.calls_handled}</p>
                              </td>
                              <td>
                                <p>{e?.ptp_generated}</p>
                              </td>
                              <td>
                                <p>{e?.kept_rate}</p>
                              </td>
                              <td>
                                <p>
                                  {e?.amount_collected_formatted ??
                                    e?.amount_collected}
                                </p>
                              </td>
                              <td>
                                <p>
                                  {e?.target_amount_formatted ??
                                    e?.target_amount ??
                                    "-"}
                                </p>
                              </td>
                              <td>
                                <p>{e?.qa_score}</p>
                              </td>
                              <td>
                                <p>{e?.aht}</p>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
      {open && <ForexViewmore orderId={id} setOpen={setOpen} />}

      {!isAgentRole && (
        <>
          <button
            onClick={changeReportFilterWidth}
            title="Global Filters"
            style={{
              position: "fixed",
              transition: "0.5s",
              top: "30%",
              right: reportFilterWidth > 0 ? reportFilterWidth + 8 : 25,
              backgroundColor:
                Object.keys(reportFilters).length > 0 ? "#271078" : "#F99E52",
              color: "white",
              padding: "10px",
              height: "40px",
              width: "40px",
              zIndex: 2001,
              borderRadius: "10%",
              border: "none",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
            }}
          >
            <FaFilter size={18} />
            {Object.keys(reportFilters).length > 0 && (
              <span
                style={{
                  position: "absolute",
                  top: "-4px",
                  right: "-4px",
                  backgroundColor: "#F99E52",
                  color: "#fff",
                  borderRadius: "50%",
                  width: "18px",
                  height: "18px",
                  fontSize: "10px",
                  fontWeight: "bold",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                {Object.keys(reportFilters).length}
              </span>
            )}
          </button>

          <ReportFilter
            width={reportFilterWidth}
            changeSideBarWidth={changeReportFilterWidth}
            onApplyFilter={handleReportFilterApply}
            onResetFilter={handleReportFilterReset}
            userRole={role}
          />

          {isReportFilterOpen && (
            <div
              className="backdrop"
              onClick={changeReportFilterWidth}
              style={{
                position: "fixed",
                inset: 0,
                backgroundColor: "rgba(0,0,0,0.35)",
                zIndex: 1999,
              }}
            />
          )}
        </>
      )}
    </div>
  );
}

export default Agentscorecard;
